"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Page"));
__export(require("./PageBody"));
__export(require("./PageHeader"));



//////////////////
// WEBPACK FOOTER
// ./src/components/Page/index.ts
// module id = 361
// module chunks = 0